export const data = {
  _id: '60e6cfe275c7ab001bb5ebb6',
  title: 'คำถามที่พบบ่อย',
  published_at: '2021-07-08T10:13:56.090Z',
  categories: [
    {
      isHidden: false,
      _id: '60e6cfe275c7ab001bb5ebb7',
      title: 'คำถามที่พบบ่อย',
      icon: 'far fa-question-circle',
      contents: [
        {
          _id: '60e6cfe275c7ab001bb5ebb8',
          question: 'ช่าง 24 FIX แตกต่างจากช่างทั่วไปอย่างไร',
          answer:
            'ช่าง 24 FIX ทุกคนต้องผ่านการทดสอบเบื้องต้นเกี่ยวกับกับฝีมือช่าง มีการตรวจสอบเอกสารยืนยันตัวบุคคล มีการตรวจสอบประวัติอาชญกรรม และช่างจะต้องดำเนินงานภายใต้การควบคุมงานจากฝ่ายปฏิบัติการของทางบริษัทฯ ที่มีการตรวจสอบตลอดเวลา',
          __v: 0,
          id: '60e6cfe275c7ab001bb5ebb8',
        },
        {
          _id: '62a6c8dce9dde5001b3c6326',
          question: 'ทำไมต้องตอบคำถามและให้ข้อมูลกับเราก่อนจองบริการ',
          answer:
            'เพื่อให้เรา สามารถจัดเตรียมช่างและเครื่องมือ ให้ตรงตามปัญหาที่ท่านแจ้งเรามา อีกทั้งทำให้เราแก้ไขปัญหาให้ท่านได้ตรงจุด และรวดเร็วมากขึ้น นอกจากนี้ ยังช่วยให้ท่านประหยัดค่าใช้จ่าย ในการสำรวจหน้างานได้อีกด้วย',
          __v: 0,
          id: '62a6c8dce9dde5001b3c6326',
        },
        {
          _id: '60f9620b795fd2001bd0c0c5',
          answer:
            'การถ่ายรูปและส่งรูปปัญหาหน้างานเข้ามาให้ทางบริษัทฯ เบื้องต้น เป็นขั้นตอนที่จะส่งผลประโยชน์ต่อตัวลูกค้าเอง เพื่อให้ฝ่ายปฏิบัติการของทางบริษัทฯ สามารถวิเคราะห์และประเมินหน้างานเบื้องต้นได้ เพื่อที่จะเพิ่มประสิทธิภาพในการประเมินราคาได้อย่างมีมาตรฐานและสามารถจัดหาช่างที่เหมาะกับปัญหาหน้างานได้อย่างถูกต้องเหมาะสม',
          question: 'ทำไมเบื้องต้นจึงต้องส่งรูปภาพหน้างาน ให้ทาง 24 FIX ประเมินก่อน',
          __v: 0,
          id: '60f9620b795fd2001bd0c0c5',
        },
        {
          _id: '60f9620b795fd2001bd0c0c6',
          question: 'ราคาของ 24 FIX เป็นมาตรฐานอย่างไร',
          answer:
            'การประเมินราคาของบริษัทฯ จะประเมินโดยยึดจากราคาทั้งหมด 3 ระดับราคา คือ ราคาซ่อมของ 24 FIX จะต้อง \n1. เป็นราคาที่ช่างสามารถดำเนินการได้และเพียงพอต่อการประกอบอาชีพ \n2. เป็นราคาที่ยึกจากราคากลางในตลาด และ \n3. เป็นราคาที่สมเหตุสมผลต่อลูกค้า โดยจะยึดจากราคากลางของตลาดและความยากง่ายของหน้างานจริง',
          __v: 0,
          id: '60f9620b795fd2001bd0c0c6',
        },
        {
          _id: '62a4a580e9dde5001b3c53a6',
          question: 'มีค่าใช้จ่ายในการประเมินหน้างานหรือไม่',
          answer:
            'การประเมินหน้างานจะขึ้นอยู่กับแต่ละกรณี บริษัทฯ ในกรณีที่งานมีความซับซ้อน และต้องการความแน่ชัดในการประเมินราคาและวิธีการซ่อม ทางบริษัทจะมีค่าตรวจหน้างาน 1,000 บาท โดยเงินนี้จะถูกนำไปเป็นส่วนลดในการซ่อมจริง',
          __v: 0,
          id: '62a4a580e9dde5001b3c53a6',
        },
        {
          _id: '62a4a580e9dde5001b3c53a7',
          question: 'งานเพิ่มคืออะไร',
          answer:
            'งานเพิ่ม คือ งานที่อยู่นอกเหนือจากขอบเขตของงานที่ได้แจ้งเอาไว้ตามใบเสนอราคาหรือข้อตกลงที่ทางบริษัทฯได้ตกลงเอาไว้กับลูกค้าตั้งแต่ต้น ซึ่งเกิดได้ทั้งจากงานที่เป็นส่วนเกี่ยวเนื่องกับงานแรกที่ทางบริษัทฯ ได้ทำการเสนอราคาเอาไว้แล้ว หรือเกิดจากงานที่ไม่ได้เกี่ยวข้องกับงานแรกที่ตกลงตามใบเสนอราคาแต่เป็นงานที่เกิดจากความต้องการของลูกค้าที่จะให้ช่างดำเนินการเพิ่มเติมนอกเหนือจากใบเสนอราคา ซึ่งทางช่าง 24 FIX จะไม่สามารถดำเนินการในส่วนของงานเพิ่มได้ จนกว่าจะมีการได้รับการยืนยันงานเพิ่มจากฝ่ายปฏิบัติการของทางบริษัทฯ เท่านั้น',
          __v: 0,
          id: '62a4a580e9dde5001b3c53a7',
        },
        {
          _id: '62a4a580e9dde5001b3c53a8',
          question: 'ชำระเงินอย่างไร จ่ายเงินสดให้ช่างหน้างานได้ไหม',
          answer:
            'การชำระเงินกับทาง 24 FIX จะเป็นการชำระเงิน โดยวิธีการโอนเงิน บัตรเครดิต หรือเช็ค ซึ่งจะต้องผ่านบริษัทฯ เท่านั้น ทีมช่างของ 24 FIX จะไม่รับเงินสดหน้างานใดๆ ทั้งสิ้นหากลูกค้าพบเจอการกระทำดังกล่าว สามารถแจ้งข้อมูลมายังบริษัทฯ ได้ทันที และ หากลูกค้ามีการตกลงกับช่างเองโดยไม่ผ่านบริษัทฯ ทางบริษัทฯ ขอสงวนสิทธิ์ในการรับผิดชอบต่องานนั้นๆ และขอยกเลิกการรับประกันงานทุกกรณี',
          __v: 0,
          id: '62a4a580e9dde5001b3c53a8',
        },
      ],
      __v: 1,
      imageIcon: {
        _id: '6344fd46b259d2001d14612e',
        name: 'question-circle.svg',
        alternativeText: '',
        caption: '',
        hash: 'question_circle_89639da560',
        ext: '.svg',
        mime: 'image/svg+xml',
        size: 0.61,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/question_circle_89639da560.svg',
        provider: 'aws-s3',
        width: 512,
        height: 512,
        related: [],
        createdAt: '2022-10-11T05:21:10.082Z',
        updatedAt: '2022-10-12T08:11:25.593Z',
        __v: 0,
        id: '6344fd46b259d2001d14612e',
      },
      id: '60e6cfe275c7ab001bb5ebb7',
    },
    {
      isHidden: false,
      _id: '62a4a6dae9dde5001b3c53b0',
      title: 'วิธีใช้โค้ดส่วนลด',
      contents: [
        {
          _id: '62a4a6dae9dde5001b3c53b1',
          question: 'การใช้โค้ดส่วนลด',
          answer:
            'ท่านสามารถใส่ชื่อโค้ด และกดเลือกใช้โค้ดที่ท่านต้องการ เมื่อเลือกและกดใช้งาน ส่วนลดจะถูกใช้งาน โดยสังเกตได้จากค่าบริการที่ต้องชำระจะลดลง',
          __v: 0,
          id: '62a4a6dae9dde5001b3c53b1',
        },
      ],
      __v: 1,
      imageIcon: {
        _id: '62d1261b75aa5e001b100863',
        name: 'promocode.svg',
        alternativeText: '',
        caption: '',
        hash: 'promocode_2df787d07e',
        ext: '.svg',
        mime: 'image/svg+xml',
        size: 2.44,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/promocode_2df787d07e.svg',
        provider: 'aws-s3',
        width: 40,
        height: 40,
        related: [],
        createdAt: '2022-07-15T08:32:27.558Z',
        updatedAt: '2022-07-23T16:52:28.601Z',
        __v: 0,
        id: '62d1261b75aa5e001b100863',
      },
      id: '62a4a6dae9dde5001b3c53b0',
    },
  ],
  createdAt: '2021-07-08T10:13:54.158Z',
  updatedAt: '2022-10-11T05:21:22.678Z',
  __v: 1,
  id: '60e6cfe275c7ab001bb5ebb6',
}
